import { render, staticRenderFns } from "./formulario.vue?vue&type=template&id=68258920"
import script from "./formulario.vue?vue&type=script&lang=js"
export * from "./formulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports